import _ from 'lodash'
import { createSelectorCreator, defaultMemoize } from 'reselect'

export const createDeepEqualitySelector = createSelectorCreator(defaultMemoize, _.isEqual)
